/**
 * Presentational width / height / fps number inputs for a Canvas settings
 * section. Purely controlled — the parent owns the values and decides how they
 * persist (TemplateDetail PATCHes them onto the template row via a Save button;
 * PromptWorkspace holds them in workspace state + the editor draft and applies
 * them live). Extracted so both surfaces render the identical input trio.
 */
export function CanvasFields({
  width,
  height,
  fps,
  onWidth,
  onHeight,
  onFps,
}: {
  width: number;
  height: number;
  fps: number;
  onWidth: (v: number) => void;
  onHeight: (v: number) => void;
  onFps: (v: number) => void;
}) {
  const inputClass =
    "w-24 rounded-lg border border-line bg-surface px-2 py-1 text-xs text-ink focus:border-line-strong focus:outline-none";

  return (
    <div className="flex flex-col gap-2 text-xs text-ink-2">
      <label className="flex items-center gap-2">
        <span className="w-14">Width</span>
        <input
          type="number"
          min={16}
          max={8192}
          value={width}
          onChange={(e) => onWidth(parseInt(e.target.value, 10) || 0)}
          className={inputClass}
        />
        <span className="text-ink-3">px</span>
      </label>
      <label className="flex items-center gap-2">
        <span className="w-14">Height</span>
        <input
          type="number"
          min={16}
          max={8192}
          value={height}
          onChange={(e) => onHeight(parseInt(e.target.value, 10) || 0)}
          className={inputClass}
        />
        <span className="text-ink-3">px</span>
      </label>
      <label className="flex items-center gap-2">
        <span className="w-14">FPS</span>
        <input
          type="number"
          min={1}
          max={120}
          value={fps}
          onChange={(e) => onFps(parseInt(e.target.value, 10) || 0)}
          className={inputClass}
        />
        <span className="text-ink-3">fps</span>
      </label>
    </div>
  );
}
